module.exports = __webpack_public_path__ + "static/media/dongle_1.a6139153.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dongle_1.png
// module id = 2137
// module chunks = 0